/* global window */
// @flow

import React from 'react'
import { Icon, Button } from 'semantic-ui-react'
import { mercury } from 'constants/inlineStyles'
import withMetricClick from '../../../withMetricClick'
import CopyToClipboard from './CopyToClipboard'

let styles = {}

type Props = {|
  +flyerTitle: string
|}

function getShareHost() {
  switch (window.location.hostname) {
    // Local development
    case 'localhost':
    case '127.0.0.1':
      return 'http://127.0.0.1:32323'
    // Production
    case 'app.peachjar.com':
    default:
      return 'https://share.peachjar.com'
  }
}

function getShareUrl() {
  return getShareHost() + window.location.pathname
}

const ShareModalButtons = ({ flyerTitle }: Props) => {
  // TODO rewrite ShareModalButtons, SocialIcons, MobileShareDropdown more functionally
  const ButtonWithFacebookMetricClick = withMetricClick('social-facebook')(
    Button
  )
  const ButtonWithTwitterMetricClick = withMetricClick('social-twitter')(Button)
  const ButtonWithCopyMetricClick = withMetricClick('share-copy-link')(Button)
  return (
    <div>
      <ButtonWithFacebookMetricClick
        as="a"
        href={`https://www.facebook.com/sharer/sharer.php?u=${getShareUrl()}`}
        target="_blank"
        fluid
        style={styles.socialButton}
        color="facebook"
      >
        <Icon as="span" name="facebook" /> Facebook
        <Icon
          className="tablet hidden"
          as="span"
          name="chevron right"
          style={styles.socialButtonRightIcon}
        />
      </ButtonWithFacebookMetricClick>
      <ButtonWithTwitterMetricClick
        as="a"
        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
          getShareUrl()
        )}&text=${flyerTitle}&hashtags=peachjar`}
        target="_blank"
        fluid
        style={styles.socialButton}
        color="twitter"
      >
        <Icon as="span" name="twitter" /> Twitter
        <Icon
          className="tablet hidden"
          as="span"
          name="chevron right"
          style={styles.socialButtonRightIcon}
        />
      </ButtonWithTwitterMetricClick>
      <CopyToClipboard
        clipboardContent={getShareUrl()}
        successTooltipPosition="right center"
      >
        <ButtonWithCopyMetricClick fluid style={styles.socialButton}>
          <Icon as="span" name="linkify" /> Copy Link
          <Icon
            className="tablet hidden"
            as="span"
            name="chevron right"
            style={styles.socialButtonRightIcon}
          />
        </ButtonWithCopyMetricClick>
      </CopyToClipboard>
    </div>
  )
}

styles = {
  socialButton: {
    margin: '.5em 0',
    textAlign: 'left',
    border: `1px solid ${mercury}`
  },
  socialButtonRightIcon: { float: 'right', paddingLeft: '1em' }
}

export default ShareModalButtons



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/ModalManager/components/ShareModalButtons.js